document.addEventListener("DOMContentLoaded", function () {
    let swipers = [];
    let swipersMobile = [];
    let swipersCompare = [];

    function initSwiperOnMobile() {
        let gridsMobile = document.querySelectorAll(".swiper-grid-mobile");
        let simpleMobiles = document.querySelectorAll(".swiper-mobile");
        let compare = document.querySelectorAll(".swiper-compare");

        gridsMobile.forEach((grid, index) => {
            let existingSwiper = grid.swiper;

            if (window.innerWidth <= 768) {
                if (!existingSwiper) {
                    let swiperInstance = new Swiper(grid, {
                        slidesPerView: 1,
                        autoplay: true,
                        centeredSlides: true,
                        createElements: true,
                        loop: false,
                        grabCursor: true,
                        initialSlide: 0,
                        keyboard: true,
                        navigation: true,
                        pagination: true,
                        simulateTouch: true,
                        lazy: { enabled: true },
                        watchSlidesProgress: true,
                        observer: true,
                        observeParents: true,
                        resizeObserver: true,
                    });

                    swipers.push(swiperInstance);
                }
            } else {
                if (existingSwiper) {
                    existingSwiper.destroy(true, true);
                    swipers = swipers.filter((s) => s !== existingSwiper);
                }
            }
        });

        simpleMobiles.forEach((mobile) => {
            let existingSwiper = mobile.swiper;

            if (window.innerWidth <= 768) {
                if (!existingSwiper) {
                    let swiperInstance = new Swiper(mobile, {
                        slidesPerView: 1,
                        autoplay: true,
                        spaceBetween: 80,
                        centeredSlides: true,
                        createElements: true,
                        loop: false,
                        grabCursor: true,
                        initialSlide: 0,
                        keyboard: true,
                        navigation: true,
                        pagination: true,
                        simulateTouch: true,
                        lazy: { enabled: true },
                        watchSlidesProgress: true,
                        observer: true,
                        observeParents: true,
                        resizeObserver: true,
                    });

                    swipersMobile.push(swiperInstance);
                }
            } else {
                if (existingSwiper) {
                    existingSwiper.destroy(true, true);
                    swipersMobile = swipersMobile.filter(
                        (s) => s !== existingSwiper
                    );
                }
            }
        });

        const hasUpgradeBlock = document.querySelector('.upgrade-block') !== null;

        compare.forEach((grid) => {
            const existing = grid.swiper;
            if (existing) return; // ne pas recréer
          
            const hasUpgradeBlock = document.querySelector('.upgrade-block') !== null;
          
            const swiperInstance = new Swiper(grid, {
              // slidesPerView en nombre fixe (pas 'auto') : Swiper calcule alors
              // lui-même la largeur de chaque slide = largeur du conteneur / N,
              // ce qui garantit exactement N cartes visibles sans qu'aucune ne
              // dépasse — plus besoin de deviner une largeur en vw/clamp() côté
              // CSS (cf. _compare-product.scss, plus de width sur .swiper-slide).
              slidesPerView: hasUpgradeBlock ? 'auto' : 1.15,
              centeredSlides: !hasUpgradeBlock,
              centeredSlidesBounds: !hasUpgradeBlock,
              centerInsufficientSlides: true,
              spaceBetween: 20,

              navigation: {
                enabled: true,
                prevEl: ".compare-prev",
                nextEl: ".compare-next",
              },
              pagination: {
                el: ".swiper-pagination",
                enabled: true,
                clickable: true,
                dynamicBullets: true,
              },

              // breakpoints: nombre de cartes visibles (et espacement) selon la largeur
              breakpoints: hasUpgradeBlock ? {
                1600: { spaceBetween: 16 },
                1800: { spaceBetween: 32 }
              } : {
                600:  { slidesPerView: 2, spaceBetween: 16 },
                1000: { slidesPerView: 3, spaceBetween: 16 },
                1300: { slidesPerView: 4, spaceBetween: 20 },
                1600: { slidesPerView: 4, spaceBetween: 16 },
                1800: { slidesPerView: 4, spaceBetween: 24 },
                2500: { slidesPerView: 4, spaceBetween: 32 }
              },
          
              // si tu veux démarrer sur la carte du milieu
              on: {
                init(sw) {
                  const mid = Math.floor(sw.slides.length / 2);
                  sw.slideTo(mid, 0, false);
                }
              },
          
              // tes options usuelles
              watchSlidesProgress: true,
              observer: true,
              observeParents: true,
              resizeObserver: true
            });
          
            swipersCompare.push(swiperInstance);
          });
          
    }

    initSwiperOnMobile();
    window.addEventListener("resize", initSwiperOnMobile);
});
